import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import 'jquery-slimscroll';
import {NavigationService} from '../services/navigation/navigation.service';
import {User} from '../models/user.model';
import {NavigationConfigurationMenuitem} from '../models/navigation-configuration-menuitem';
import {HelperService} from '../services/helperService';
import {TranslateService} from "@ngx-translate/core";


declare let $: any;


@Component({
	selector: 'tig-navigation',
	templateUrl: 'navigation.template.html'
})
export class NavigationComponent implements AfterViewInit, OnInit {

	public current_user: User;
	public client: { id: number, name: string, logo: string };
	public navigation: NavigationConfigurationMenuitem;


	constructor(
		private router: Router,
		private navigation_service: NavigationService,
		public helper_service: HelperService,
		private OBJ_translation_service: TranslateService
	) {
	}


	ngOnInit(): void {

		// get navigation config
		this.navigation = this.navigation_service.OBJ_navigation_config;

		// get client id and current user from local storage
		this.client = this.helper_service.getFromLocalstorage('client');
		this.current_user = this.helper_service.getFromLocalstorage('current_user');

		// console log
		this.helper_service.log
		(
			{class: 'NavigationComponent', function: 'ngOnInit'},
			{current_user: this.current_user, client: this.client}
		);

	}


	ngAfterViewInit(): void {

		$('#side-menu').metisMenu();

		if ($('body').hasClass('fixed-sidebar')) {
			$('.sidebar-collapse').slimscroll({
				height: '100%'
			});
		}

		// $(document).on('mouseover', '.nav-second-level li a', function() {
		// 	$(this).css('text-indent','-20px');
		// });
		// $(document).on('mouseleave', '.nav-second-level li a', function() {
		// 	$(this).css('text-indent',0);
		// });

	}

	getLabel(menu_item: NavigationConfigurationMenuitem, prefix: string = "") {
		let label: string = menu_item.route;
		if (menu_item.label) {
			label = menu_item.label;
		}
		return this.OBJ_translation_service.instant(prefix + label)
	}
}
